import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Auth from '@/auth/Auth'
import PresentesRecebidos from '@/views/PresentesRecebidos'
import CriarPresente from '@/views/CriarPresente'
import Agenda from '@/views/Agenda'
import Inscricoes from '@/views/Inscricoes'
import Dispositivos from '@/views/Dispositivos'
import Checkin from '@/views/Checkin'
import Checkout from '@/views/Checkout'
import Confirmacao from '@/views/Pages/Confirmacao'
import Inicio from '@/views/Inicio'
import Resumo from '@/views/Pages/Resumo'
import Convidados from '@/views/Convidados'
import NovoCadastro from '@/views/Pages/NovoCadastro'

import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [
  { name: 'home', path: '/home', component: Home, meta: { requiresAdmin: true } },
  { name: 'auth', path: '/login', component: Auth, meta: { requiresAdmin: false } },
  { name: 'recebidos', path: '/recebidos', component: PresentesRecebidos, meta: { requiresAdmin: true } },
  { name: 'criarpresente', path: '/criarpresente', component: CriarPresente, meta: { requiresAdmin: true } },
  { name: 'agenda', path: '/agenda', component: Agenda, meta: { requiresAdmin: true } },
  { name: 'inscricoes', path: '/inscricoes', component: Inscricoes, },
  { name: 'dispositivos', path: '/dispositivos', component: Dispositivos, meta: { requiresAdmin: true } },
  { name: 'checkin', path: '/checkin', component: Checkin, meta: { requiresAdmin: true } },
  { name: 'checkout', path: '/checkout', component: Checkout, meta: { requiresAdmin: true } },
  { name: 'confirmacao', path: '/confirmacao', component: Confirmacao, meta: { requiresAdmin: false } },
  { name: 'inicio', path: '/', component: Inicio, meta: { requiresAdmin: false } },
  { name: 'resumo', path: '/resumo', component: Resumo, meta: { requiresAdmin: false } },
  { name: 'convidados', path: '/convidados', component: Convidados, meta: { requiresAdmin: false } },
  { name: 'novocadastro', path: '/novocadastro', component: NovoCadastro, meta: { requiresAdmin: false } },
]

/* const router = new VueRouter({
  routes
}) */

const router = new VueRouter({
  mode: 'history',
  routes
})

//Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = sessionStorage.getItem(userKey)

  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const user = JSON.parse(json)
    if (user === "GERENTE" || user === "ADMIN" || user === "CHECKIN" || user === "CHECKOUT")
      next()
    else
      next({ path: '/' })
  } else {
    next()
  }
})

export default router